export class ChecklistListItemEntity {
  public id!: string;
  public investigationTypeId!: string;
  public investigationTypeName!: string;
  public stepCount!: number;
  public displayOnCases!: boolean;
}
